import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(1),
    textAlign: "left",
    marginBottom: "20px",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      justifyContent: "flex-end",
      textAlign: "center",
    },
  },
  label: {
    color: "#9A9A9A",
    fontWeight: 600,
    size: "14px",
    textTransform: "uppercase",
  },
  leftContainer: {
    width: "40%",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      order: 2,
      width: "100%",
      marginRight: "initial",
      marginBottom: "20px",
    },
  },
  middleContainer: {
    width: "40%",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      order: 2,
      width: "100%",
      marginRight: "initial",
    },
  },
  rightContainer: {
    width: "20%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      order: 0,
      width: "auto",
    },
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#00003D",
    opacity: 1,
    whiteSpace: "nowrap",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  textField: {
    "&.Mui-disabled": {
      color: "black",
    },
    "$.MuiInput-underline": {
      borderBottom: "none",
    },
  },
}))

export default styles
